/**
 * Element - wysiwyg
 */

export const wysiwyg = ():void => {

  // Run the script for each individual element found on the page
  const elementSelector = document.querySelectorAll('.js-wysiwyg') as unknown as HTMLElement[]
  elementSelector.forEach((component:HTMLElement) => {

  })

}
